import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaArrowRight, FaGasPump, FaRoad, FaRoute, FaWallet } from 'react-icons/fa';
import Header from '../components/Common/Header';
import Seo from '../components/Common/Seo';
import { routeGuides } from '../data/routeGuides';
import '../css/route-guide.css';

const GuidesIndexPage = () => {
  const navigate = useNavigate();
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: 'South Africa Route Guides',
    description: 'Browse South African route cost guides covering fuel planning, toll exposure and trip comparison.',
    url: 'https://www.whe2.com/guides'
  };

  return (
    <div className="route-guide-page">
      <Seo
        title="South Africa Route Guides | Fuel, Toll and Trip Cost Planning | Whe2"
        description="Browse South African route guides for fuel planning, toll costs, distance and trip comparison."
        path="/guides"
        jsonLd={jsonLd}
      />
      <Header />
      <main className="route-guide-main">
        <div className="route-guide-shell">
          <section className="guide-hero">
            <p className="guide-kicker">Route guide hub</p>
            <h1>South Africa Route Guides</h1>
            <p className="guide-lead">
              Browse South African route guides that focus on fuel cost, toll cost, drive time and
              practical trip planning. Use them as a faster way to compare major routes before
              moving into the Whe2 planner.
            </p>
            <div className="guide-metrics">
              <div className="guide-metric">
                <div className="guide-metric-icon"><FaRoute /></div>
                <div>
                  <strong>Major routes</strong>
                  <span>Focused on high-intent South African corridors</span>
                </div>
              </div>
              <div className="guide-metric">
                <div className="guide-metric-icon"><FaWallet /></div>
                <div>
                  <strong>Trip cost context</strong>
                  <span>Fuel, toll and total route-planning trade-offs</span>
                </div>
              </div>
              <div className="guide-metric">
                <div className="guide-metric-icon"><FaGasPump /></div>
                <div>
                  <strong>Fuel planning</strong>
                  <span>Vehicle-based planning points for more realistic estimates</span>
                </div>
              </div>
              <div className="guide-metric">
                <div className="guide-metric-icon"><FaRoad /></div>
                <div>
                  <strong>Distance and time</strong>
                  <span>Quick reference before opening the planner</span>
                </div>
              </div>
            </div>
          </section>

          <section className="guide-card guide-card-wide">
            <h2>Available route guides</h2>
            <div className="guide-related-grid">
              {routeGuides.map((guide) => (
                <Link key={guide.slug} className="guide-related-link" to={guide.path}>
                  <strong>{guide.shortTitle}</strong>
                  <span>{guide.description}</span>
                </Link>
              ))}
            </div>
          </section>

          <section className="guide-card guide-card-wide">
            <h2>Want the full planning experience?</h2>
            <p>
              Download the Whe2 app to compare route options with fuel estimates, toll costs and
              trip totals using your own vehicle details.
            </p>
            <div className="guide-cta-row">
              <button
                type="button"
                className="guide-primary-cta"
                onClick={() => navigate('/', { state: { scrollTarget: 'download' } })}
              >
                Download Whe2 <FaArrowRight />
              </button>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default GuidesIndexPage;
